import mutations from './mutations'
import * as actions from './actions'

const state = {
  selected_restriction: {},
  restrictions : []
}

export default {
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/restrictions/index.js